import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "../firebase/config";
export async function removeManagerFromTeam(teamId, userId, _seasonIds = []) {
    const callable = httpsCallable(cloudFunctions, "removeManager");
    await callable({ teamId, userId });
}
